import { render, staticRenderFns } from "./NewBlankLeadPage.vue?vue&type=template&id=04ca9bf0&"
import script from "./NewBlankLeadPage.vue?vue&type=script&lang=js&"
export * from "./NewBlankLeadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports